import { render, staticRenderFns } from "./AppUser.vue?vue&type=template&id=7060de20&"
import script from "./AppUser.vue?vue&type=script&lang=js&"
export * from "./AppUser.vue?vue&type=script&lang=js&"
import style0 from "./AppUser.vue?vue&type=style&index=0&id=7060de20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports